import type { IconSvgObject } from './types';

const Activity05Icon: IconSvgObject = [
  ["path", { d: "M22 6V18C22 19.1046 21.1046 20 20 20H4C2.89543 20 2 19.1046 2 18V6C2 4.89543 2.89543 4 4 4H20C21.1046 4 22 4.89543 22 6Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M2 14H6C6.62951 14 7.22229 13.7036 7.6 13.2L11.2 8.4C11.3889 8.14819 11.6852 8 12 8C12.3148 8 12.6111 8.14819 12.8 8.4L16.4 13.2C16.7777 13.7036 17.3705 14 18 14H22", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }]
];

export default Activity05Icon;
